<template>
  <div style="overflow-x: hidden;background-color: white;position: absolute;left: 0;right: 0;top: 0" class="bg">
    <Navigator/>
    <SliderBanner :slider="slider"/>
    <FuncTwoCard :cardData="cardData" title="直播短视频"/>
    <IntroCard :funcData="introObj" :mode="1"/>
    <IntroCard :funcData="introObj1" :mode="2"/>
    <Footer/>
    <ContactFloat/>
  </div>
</template>

<script>
import Navigator from '../widgets/navigator'
import Footer from '../widgets/footer'
import SliderBanner from '../widgets/SliderBanner'
import FuncTwoCard from '../widgets/func-two-card'
import IntroCard from './widgets/intro-card'
import ContactFloat from '../widgets/contact-float.vue'

export default {
  components: {
    Navigator,
    IntroCard,
    FuncTwoCard,
    SliderBanner,
    ContactFloat,
    Footer
  },
  data() {
    return {
      cardData: [
        {
          title: '低成本引导分享',
          subTitle: '可通过分享给自己的好友,获得抽奖机会,快速积累大量人气',
          img: require('@/assets/images/index/game/card1.png')
        },
        {
          title: '促单购物,激励下单',
          subTitle: '可设置订单最低门槛为 N 元，每天最多可获得 N 次',
          img: require('@/assets/images/index/game/card2.png')
        },
        {
          title: '限制中奖次数',
          subTitle: '可设置每人最多有 N 次,每人每日有 N 次抽奖机会',
          img: require('@/assets/images/index/game/card3.png')
        },
        {
          title: '奖品的中奖率限制',
          subTitle: '可设置每人最多可中奖 N 次,每人最多有  N 次中奖次数',
          img: require('@/assets/images/index/game/card4.png')
        }
      ],
      introObj: {
        title: '欢乐砸金蛋',
        subTitle: '快速积累大量人气；低成本引导分享和复购',
        desc: '后台可设置多个奖品,和限制中奖次数,即每人最多有 N 次,每人每日有 N 次抽奖机会,还有每个奖品的中奖率,可个性化活动页面',
        imgUrl: require('@/assets/images/index/game/img2.png'),
        funcInfo: {
          leftFunc: [

          ],
          rightFunc: [

          ]
        }
      },
      introObj1: {
        title: '开心果园',
        subTitle: '',
        desc: '后台可设置多个奖品,和限制中奖次数,即每人最多有 N 次,每人每日有 N 次抽奖机会,还有每个奖品的中奖率,可个性化活动页面',
        imgUrl: require('@/assets/images/index/game/img3.png'),
        funcInfo: {
          leftFunc: [
            {
              title: '完善的成长奖励体系',
              subDesc: '拉新、留存、签到得水滴\n' +
                  '天天玩，好玩有趣黏住用户'
            },
            {
              title: '打品牌、更灵活',
              subDesc: '支持自定义场景、养成物及养成规则'
            },
            {
              title: '促拉新、留存',
              subDesc: '支持分享好友助力、每日整点领取'
            }
          ],
          rightFunc: [
            {
              title: '促转化',
              subDesc: '支持可以随时更换已经选择好的奖品'
            },
            {
              title: '直接引流',
              subDesc: '可后台设置想要跳转的页面,如商品活动页，直接引导跳转'
            },
            {
              title: '引流幸运大抽奖、砸金蛋',
              subDesc: '通过玩幸运大抽奖和砸金蛋游戏,来获得水滴'
            }
          ]
        }
      },
      funcData: [
        {
          title: '秒杀活动',
          subTitle: '秒杀活动是基于商品的促销工具，不仅仅会在短时间内将商品销售完，还会短时间内获得巨大流量，活动开始后自动展示促销价，结束恢复原价。是推新品和爆品的有力工具，可以快速有效地提升商品的订单转化率。',
          carouseImg: require('@/assets/images/index/mall/banner1.png')
        },
        {
          title: '优惠券营销',
          subTitle: '千人千面、智能发券，活动转化效果佳；根据不同顾客特性、营销节点、活动场景智能发放优惠券,保证优惠券使用率,「优惠」+「精准」双招促转化，顾客更爱买，帮助商家获客拉新,下单转化,提高客单,留存复购',
          carouseImg: require('@/assets/images/index/mall/banner2.png')
        },
        {
          title: '可视化自定义编辑',
          subTitle: '可视化自定义编辑平台，页面装修随心DIY！智莺系统采用可视化模板设计方式，让首页、导航、楼层、广告位、专题、商家店铺以及移动端可以根据自己网站的需求随意变动装修；系统自带多套首页模板，为运营者个性化设计自己的商城提供了更多的选择。',
          carouseImg: require('@/assets/images/index/mall/banner3.png')
        }
      ],
      slider: {
        image: require('@/assets/images/index/game/phone.png'),
        title: '游戏活动',
        desc: "吸粉裂变，流量曝光、增长获客，互动类小游戏是你运营的好工具"
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
